// Una decisión = una fila (flujo.md #1, Entrega 3): la subida que pidió un agente va EN la fila de ese agente («Revisar»),
// en su chat («Revisar la subida») y primero en Ctrl+K; la sección de subidas sueltas de la lista solo lleva las que no
// tienen agente a la vista. La bandeja (store.ts) es la única fuente; aquí, PURO, de quién es cada subida.
import type { Despliegue } from './api';

/**
 * De quién es una subida: solo si se sabe seguro y sigue vivo en el panel. «Creo que lo pidió» (`seguro: false`) no se
 * cuelga de nadie: una subida en la fila equivocada es peor que una suelta.
 */
export function agenteDeSubida(d: Pick<Despliegue, 'pedidoPor'>): string | null {
  return d.pedidoPor && d.pedidoPor.seguro && d.pedidoPor.vivo ? d.pedidoPor.agentId : null;
}

/** Por agente, su subida pendiente (si tiene varias, la que más lleva esperando: la fila dice una). */
export function subidasPorAgente(pendientes: readonly Despliegue[]): ReadonlyMap<string, Despliegue> {
  const mapa = new Map<string, Despliegue>();
  for (const d of subidasEnOrden(pendientes)) {
    const id = agenteDeSubida(d);
    if (id && !mapa.has(id)) mapa.set(id, d);
  }
  return mapa;
}

/** Las subidas que van en la sección suelta: las que no están en la fila de un agente que se ve en la lista. */
export function subidasSueltas(pendientes: readonly Despliegue[], enFilas: ReadonlySet<number>): Despliegue[] {
  return pendientes.filter((d) => !enFilas.has(d.runId));
}

/** La que más lleva esperando, delante (Ctrl+K y la fila). */
export function subidasEnOrden(pendientes: readonly Despliegue[]): Despliegue[] {
  return [...pendientes].sort((a, b) => a.creadoEn.localeCompare(b.creadoEn));
}
